module.exports = __webpack_public_path__ + "b3f9342fd78356170d46795577bf921b.svg";